Vue.component('adminMedals', {
  template: templates.adminMedals,
  data() {
    return {
      model: {
        edit: false,
        medal: {
          id: null,
          name: null,
          description: null,
          active: false,
          wins: 0,
          cards:[{ cardId: null, tier: 0 }],
          level: 0,
          isCardActive: false,
          type: null,
          selectedMode: 'any',
          selectedTier : 0
        },
        medals: {},
        cards: [{ cardId: null, tier: 0 }],
        wins: 0,
     
        cardAmount: 0,
        cardTier: [
            {
              name: 'Standard Card'
            },
            {
              name: 'Ultra Card'
            },
            {
              name: 'Legendary Card'
            }
        ],
        types: {},
        cardType:[
          {
            name: ''
          },
          {
            name: 'Standard Card'
          },
          {
            name: 'Ultra Card'
          },
          {
            name: 'Legendary Card'
          }
        ]
      },
      cards: {},
      allCards: {}
    }
  },
  watch: {
    'model.medal.type': function() {
      this.filterCards();
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.getTypes();
    c.getCards();
     c.$root.$on('remove-existing-image', data => {

      c.removeCurrentFile(data);
    })
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      medalService.get()
        .then(function (response) {
          
          for (let d of response.data) {
            d.image = `${root}/images/medals/${d.id}.png`;
            d.video = `/videos/medals/${d.id}.webm`;
            data[`${d.id}`] = d;
          }
          c.model.medals = data;
          c.$root.$emit('getMedals', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
       
    },
    getTypes() {
      const c = this;
      let data = {};

      typeService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.types = data;
          // c.$root.$emit('types', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getCards() {
      const c = this;
      let data = {};

      cardService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.allCards = data;
          c.filterCards()
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    filterCards() {
      const c = this;
      const selectedType = c.model.medal.type;

      console.log(selectedType)

      if (!selectedType || selectedType === '' || selectedType === null) {
        c.cards = c.allCards;
        return;
      }

      let filtered = {};
      for (let key in c.allCards) {
        if (c.allCards[key].type == selectedType) {
          filtered[key] = c.allCards[key];
        }
      }
      c.cards = filtered;
    },
    ensureCardsArray(cards) {
      if (!cards || !Array.isArray(cards) || cards.length === 0) {
        return [{ cardId: null, tier: 0 }];
      }

      // Map the API card structure to the format needed by the component
      return cards.map(card => ({
        cardId: card.cardId || null,
        tier: card.tier || 0
      }));
    },
    edit(id) {
      const c = this;
      let data = c.model.medals[`${id}`];

      if (id == c.model.medal.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      const cardsArray = c.ensureCardsArray(data.cards);

      c.model.medal = {
        id: id,
        name: data.name,
        description: data.description,
        active: data.active,
        wins: data.wins || 0,
        isCardActive: data.isCardActive || false,
        type: data.type || null,
        selectedMode: data.selectedMode || 'any',
        cards: cardsArray,
        level: data.level || 0,
        images: data.images
      };

      c.model.cards = c.model.medal.cards;
      c.model.wins = data.wins || 0;
      c.model.cardAmount = cardsArray.length > 0 ? cardsArray.length - 1 : 0;
    },
    add() {
      const c = this;
      c.reset();
      c.model.edit = true;
    },
    save() {
      const c = this;

      const data = c.model.medal

      console.log(data)

      // Basic validations
      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (!data.description) {
        utils.alert.error('Description is required');
        return;
      }

      if (data.wins === null || data.wins === undefined || data.wins === '') {
        utils.alert.error('Wins is required');
        return;
      }

      // Card validations when card mode is active
      if (data.isCardActive) {
        if (!data.selectedMode || data.selectedMode.trim() === '') {
          utils.alert.error('Mode is required when card is active');
          return;
        }

        // Check if at least one of: type, cardId, or tier has data
        const hasType = data.type !== null && data.type !== undefined && data.type !== '';
        const hasCardId = data.cards && data.cards[0] && data.cards[0].cardId !== null && data.cards[0].cardId !== '';
        const hasTier = data.cards && data.cards[0] && data.cards[0].tier !== 0 && data.cards[0].tier !== null && data.cards[0].tier !== undefined;

        if (!hasType && !hasCardId && !hasTier) {
          utils.alert.error('At least one of Card Type, Card, or Card Tier must be selected when card is active');
          return;
        }

        // Validate additional cards if they exist
        if (data.cards && data.cards.length > 1) {
          for (let i = 1; i < data.cards.length; i++) {
            const card = data.cards[i];

            if (!card.cardId) {
              utils.alert.error('Card ' + (i + 1) + ' must have a card selected');
              return;
            }

            if (card.tier === null || card.tier === undefined || card.tier === '') {
              utils.alert.error('Card ' + (i + 1) + ' must have a tier selected');
              return;
            }
          }
        }
      }

      console.log(c.model.medal);

      medalService.save(data)
        .then(function (response) {

          if (data.id) {
            c.model.medals[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.medals[`${data.id}`] = data;
          }

          c.reset();

          utils.alert.success('Saved!');

        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    handleMediaUpload(data){
      const c = this;
      if (!c.model.medal.images) {
        c.model.medal.images = {};
      }
      const currentKeys = Object.keys(c.model.medal.images);

      // Determine the next key (numeric)
      const nextKey = currentKeys.length > 0 ? Math.max(...currentKeys.map(Number)) + 1 : 0;

      // Add the new image
      for(i=0;i<data.files.length;i++){
        c.model.medal.images[nextKey + i] = data.files[i].filename;
      }
    },
    removeCurrentFile(data){
      const c = this;

      const id = c.model.medal.id
      uploadService.deleteFile('medals', id, data.image)
      .then(function (response) {

        console.log(response.data.id)
        Vue.delete(c.model.medal.images, data.index)
        utils.alert.success('File Removed!');
      })
      .catch(function (error) {
        utils.alert.error(error);
      });
    },
    getMedalsUrl(){
      const c = this;

      let id = c.model.medal.id;
      const url = `${root}/images/medals/${id}/`;
      return url;
      
    },
    incrementCards() {
      const c = this;
      c.model.cardAmount++;
      c.model.medal.cards.push({ cardId: null, tier: 0 });
    },
    removeCard(index) {
      const c = this;
      if (c.model.cardAmount > 0) {
        c.model.cardAmount--;
        c.model.medal.cards.splice(index, 1);
      }
    },
    updateCard(index, field, value) {
      const c = this;
      if (!c.model.medal.cards[index]) {
        c.model.medal.cards[index] = { cardId: null, tier: 0 };
      }
      c.model.medal.cards[index][field] = field === 'tier' ? parseInt(value) : value;
    },
    updateField(field, value) {
      const c = this;
      if (field === 'wins') {
        c.model.wins = parseInt(value);
      }
    },
    reset() {
      const c = this;
      c.model.edit = false;

      c.model.medal = {
        id: null,
        name: null,
        description: null,
        active: false,
        wins: 0,
        cards: [{ cardId: null, tier: 0 }],
        level: 0,
        isCardActive: false,
        type: null,
        selectedMode: 'any'
      };

      c.model.cards = [{ cardId: null, tier: 0 }];
      c.model.wins = 0;
      c.model.cardAmount = 0;
    }
  }
});